"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TripAdvisorRaiting_1 = __importDefault(require("./TripAdvisorRaiting"));
const TripAdvisorReviewComment_1 = __importDefault(require("./TripAdvisorReviewComment"));
const TAReviewWrap = styled_components_1.default.div(({ theme: { space } }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: space[4],
}));
const TAReviewHeader = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(theme.tripAdvisor.reviewHeader));
const TARating = (0, styled_components_1.default)(TripAdvisorRaiting_1.default)((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.icon': {
        variant: [`tripAdvisor.icon.small`, 'icons.lg'],
    },
}));
// TODO: move TripAdvisorReview outside of rating folder
const TripAdvisorReviewComponent = props => {
    const { region, rating, date, author, message, subratings, className, } = props;
    return (react_1.default.createElement(TAReviewWrap, { className: className },
        react_1.default.createElement(TAReviewHeader, { className: "review-header" },
            rating && react_1.default.createElement(TARating, { rating: rating }),
            react_1.default.createElement("p", { className: "review-description" },
                author && (react_1.default.createElement("span", { className: "review-author", "data-id": "ta-review-author" }, author)),
                region && (react_1.default.createElement("span", { className: "review-region", "data-id": "ta-review-region" }, region)),
                date && (react_1.default.createElement("span", { className: "review-date", "data-id": "ta-review-date" }, date)))),
        react_1.default.createElement(TripAdvisorReviewComment_1.default, { title: (message === null || message === void 0 ? void 0 : message.title) || '', text: (message === null || message === void 0 ? void 0 : message.text) || '', subRatings: subratings || [] })));
};
exports.default = TripAdvisorReviewComponent;
//# sourceMappingURL=TripAdvisorReview.js.map